import { Component, EventEmitter, OnInit, Output, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { PropertyService } from '../properties/service/property.service';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { LoginService } from '../login/login.service';
import { SharedService } from 'src/app/core/shared/shared.service';
import { CreateUserComponent } from '../create-user/create-user.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [DialogModule, ButtonModule, InputTextModule, CommonModule, TooltipModule, FormsModule, CreateUserComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class headerComponent implements OnInit, OnDestroy {
  userDetailsVisible: boolean = false;
  editProfileVisible: boolean = false;
  currentUserForEdit: any = null;
  sidebarOpen: boolean = false;
  userInfo: any = null;
  notifications: any[] = [];
  unreadCount: number = 0;
  notificationsVisible: boolean = false;
  baseUrl = environment.baseUrl;
  superAdminDomain = environment.superAdminDomain;
  isImpersonating: boolean = false;

  properties: any[] = [];
  selectedPropertyId: string | null = null;

  private notificationSubscription!: Subscription;

  constructor(
    private router: Router,
    private authService: PropertyService,
    private loginService: LoginService,
    private sharedService: SharedService,
    private eRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.getUserInfo();
    this.fetchNotifications();

    // this.notificationSubscription = interval(10000).subscribe(() => {
    //   this.fetchNotifications();
    // });
  }

  ngOnDestroy(): void {
    this.notificationSubscription?.unsubscribe();
  }

  async getUserInfo(): Promise<void> {
    try {
      this.authService.getUserInfo().subscribe(user => {
        this.userInfo = user;
        console.log("USER INFO IN HEADER ===================");
        console.log(user);
        this.selectedPropertyId = user.property_id || null;
        if (user && user.properties && Array.isArray(user.properties) && user.properties.length > 0) {
          this.properties = user.properties;
          if(user.impersonationLevel && user.impersonationLevel > 0){
            this.isImpersonating = true;
          }
        }
      });
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  }

  switchProperty(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const propertyId = selectElement.value;
    this.loginService.impersonate(propertyId).subscribe((res: any) => {
      console.log('Switch Property Response:', res);
      window.location.href = `https://${res.redirectUrl}`;
    });
  }

  async exit() {
    this.loginService.exitImpersonation().subscribe(res => {
      localStorage.setItem('token', res.accessToken);
      console.log('Exit Impersonation Response:', res);
      window.location.href = `https://${this.superAdminDomain}/properties`;
    });
  }

  async fetchNotifications(): Promise<void> {
    try {
      const data = await this.authService.getNotifications().toPromise();
      this.notifications = data ?? [];
      this.unreadCount = this.notifications.filter(n => !n.read).length;
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }

  toggleUserDetails(): void {
    this.userDetailsVisible = !this.userDetailsVisible;
  }

  closeUserDetails(): void {
    this.userDetailsVisible = false;
  }

  toggleNotifications(): void {
    this.notificationsVisible = !this.notificationsVisible;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.notificationsVisible = false;
      this.userDetailsVisible = false;
    }
  }

  markAsRead(notification: any): void {
    notification.read = true;
    this.unreadCount = this.notifications.filter(n => !n.read).length;
  }

  showEditProfile(): void {
    this.userDetailsVisible = false;
    this.sharedService.loadCurrentUser().subscribe({
      next: (user) => {
        this.currentUserForEdit = user;
        this.editProfileVisible = true;
      },
      error: () => {
        // Fall back to token data if API fails
        this.currentUserForEdit = { ...this.userInfo, _id: this.userInfo?.user_id };
        this.editProfileVisible = true;
      }
    });
  }

  onEditProfileClose(): void {
    this.editProfileVisible = false;
    this.currentUserForEdit = null;
    this.getUserInfo();
  }

  logout(): void {
    localStorage.removeItem('accessToken');
    this.router.navigate(['/login']);
  }

  @Output() sidebarToggle = new EventEmitter<void>();

  get isTenant(): boolean {
    return this.userInfo?.user_type === 'tenant';
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
    this.sidebarToggle.emit();
  }
}
